export const SUBSCRIPTION_COOKIE_NAME = "ai-primer-subscribed-v2";
export const SUBSCRIPTION_COOKIE_VALUE = "1";
export const SUBSCRIPTION_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180; // 180 days
export const SUBSCRIPTION_EVENT_NAME = "subscription:subscribed:v2";
